import { useCallback } from 'react';
import { useBeforeUnload } from 'react-router-dom';

interface UnsavedChangesPromptProps {
	hasUnsavedChanges: boolean;
}

export const UnsavedChangesPrompt = ({ hasUnsavedChanges }: UnsavedChangesPromptProps) => {
	useBeforeUnload(
		useCallback(
			(event: BeforeUnloadEvent) => {
				if (hasUnsavedChanges) {
					event.preventDefault();
					// Support legacy cases
					event.returnValue = '';
				}
			},
			[hasUnsavedChanges]
		),
		{ capture: true }
	);

	return <></>;
};
